import * as React from "react";

import {cs} from "@Common/react/chain-services";

import {ImageFieldCreator} from "./imageFieldCreator";
import {CustomizationTile} from "./customizationTile";


export const QrCodes = ({orderId, qrCodeData, domRef, updateImage, onApplyImageFromPhotoDashboard, showGallery, imageGuidelinesModal, allowedGalleryTabs, editable, setUnsavedChanges}) => cs(
    ({}) =>
        <CustomizationTile
            domRef={domRef}
            header={<h3 className="customization-tile-title" xd-qa-type="label" xd-qa-name="QR Codes">QR Codes</h3>}
            imageGuidelinesModal={imageGuidelinesModal}
            imageType="qr code"
            photoCount={qrCodeData.length}
        >
            {ImageFieldCreator({
                orderId: orderId,
                data: qrCodeData,
                imageType: "qrCode",
                updateImage,
                showGallery,
                onApplyImageFromPhotoDashboard,
                editable,
                allowedGalleryTabs,
                setUnsavedChanges
            })}
        </CustomizationTile>
);